/* Bird Journey — scroll-gesteuerte Vogel-Reise (sections/bird-journey.liquid).
   Zeichnet die komplette Pfad-Geometrie in echten Pixeln: Scroll-Fortschritt 0→1
   treibt Vogel + Avatar-Reveal + das progressive Zeichnen des gepunkteten Pfads.
   Danach (gepinnt, GSAP ScrollTrigger) Phase 2: Avatare fliegen auf ihre
   Ziel-Slots (Kontakte → Chat im Phone, Träger:innen → übers Armband). */
(function () {
  'use strict';

  function initBirdJourney(section) {
    var stage = section.querySelector('.bj-stage');
    // Referenz für den CSS-Scale: die Scale-Ebenen (.bj-scale, deckungsgleich mit
    // der Stage) tragen die Scale-Stufen-Transforms — die Stage selbst bleibt
    // untransformiert (Stacking). Alle Maß-Messungen laufen über diese Ebene.
    var scaleEl = stage ? (stage.querySelector('.bj-scale-path') || stage.querySelector('.bj-scale') || stage) : null;
    var glowEl = stage ? stage.querySelector('.bj-glow') : null;
    var svg = section.querySelector('.bj-path');
    var pathEl = svg ? svg.querySelector('.bj-path-line') : null;
    var revealEl = svg ? svg.querySelector('.bj-reveal-line') : null;
    var grad = svg ? svg.querySelector('linearGradient') : null;
    var bird = section.querySelector('.bj-bird');
    var birdFlip = section.querySelector('.bj-bird-flip');
    var avatars = Array.prototype.slice.call(section.querySelectorAll('.bj-avatar'));
    var bubbles = avatars.map(function (a) { return a.querySelector('.bj-bubble'); });
    if (!stage || !svg || !pathEl) return;

    // Pfad-Settings aus dem Shopify-Editor (Pixelwerte, via data-Attribute).
    var DOT_W_PX = parseFloat(section.dataset.dotW) || 3;
    var DOT_GAP_PX = parseFloat(section.dataset.dotGap) || 9;
    // Fallback-Landeposition des Vogels in Phase 2 (% Breite / Viewport-Höhe) —
    // regulär landet er auf den Träger:innen-Slots (setupEntry).
    var PH2_LAND_X = 0.42, PH2_LAND_Y = 0.38;

    // ── EINE Geometrie für Avatare UND Pfad ──
    // Der Pfad ist 1:1 die Referenz-SVG "Ellipse 1942" (viewBox 1502×1002), Kreis:
    // Mitte (750.75, 750.75), Radius 741. Die Avatare sitzen auf dem OBEREN Bogen
    // exakt dieses Kreises → per Konstruktion auf dem Pfad.
    var VBW = 1502, VBH = 1002;
    var CX = 750.75, CY = 750.75;
    var DESKTOP_SCALE = 0.93;      // Desktop-Kreis 7% kleiner (Avatare + Pfad gemeinsam)
    var R = 741 * DESKTOP_SCALE;
    var N = avatars.length;

    // Fester Pfad-d-String aus der Referenz-SVG (unverändert übernommen).
    var PATH_D = 'M727.748 923.4C735.387 923.633 743.055 923.75 750.75 923.75C1159.99 923.75 1491.75 1159.99 1491.75 750.75C1491.75 341.507 1159.99 9.75 750.75 9.75C341.507 9.75 9.75 341.507 9.75 750.75';
    // Vorderer Referenz-Teilpfad bis zum 3-Uhr-Punkt: seine Länge im skalierten
    // Desktop-d = die Stelle, an der der Vogel den Kreis Richtung Phase 2 verlässt.
    var EXIT_D = 'M727.748 923.4C735.387 923.633 743.055 923.75 750.75 923.75C1159.99 923.75 1491.75 1159.99 1491.75 750.75';

    // Avatare symmetrisch um 12 Uhr auf dem oberen Bogen verteilen (0° = rechts).
    var SPREAD = 150;
    function avatarAngle(i) {
      if (N <= 1) return 90;
      return (90 + SPREAD / 2) - (i / (N - 1)) * SPREAD;
    }

    // Ellipse-Faktoren (CSS-Variablen der Höhen-Scale-Stufen): bei flachen Fenstern
    // wird der Ring horizontal gestreckt + vertikal gestaucht. Wirken auf Pfad-d
    // UND Avatar-Positionen (gleiche Geometrie). 1/1 = Kreis.
    var EK = { x: 1, y: 1 };
    function readEllipse() {
      var cs = getComputedStyle(stage);
      var ex = parseFloat(cs.getPropertyValue('--bj-ellipse-x'));
      var ey = parseFloat(cs.getPropertyValue('--bj-ellipse-y'));
      EK.x = ex > 0 ? ex : 1;
      EK.y = ey > 0 ? ey : 1;
    }
    function ptOnCircle(deg) {
      var a = deg * Math.PI / 180;
      return { x: CX + Math.cos(a) * R * EK.x, y: CY - Math.sin(a) * R * EK.y };
    }

    // Skaliert alle absoluten Koordinaten eines d-Strings (nur M/C-Koordinatenpaare)
    // um (cx,cy) mit sx/sy — echte Koordinaten, damit getPointAtLength() stimmt
    // (ein reiner SVG-transform würde nur visuell skalieren).
    function scalePathD(d, cx, cy, sx, sy) {
      var pairIdx = 0;
      return d.replace(/-?\d*\.?\d+(?:e[-+]?\d+)?/gi, function (numStr) {
        var v = parseFloat(numStr);
        var isX = (pairIdx % 2) === 0;
        pairIdx++;
        var c = isX ? cx : cy, s = isX ? sx : sy;
        return (c + (v - c) * s).toFixed(3);
      });
    }

    function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }
    var avatarBase = [];   // Kreis-Positionen der Avatare — Startpunkte für Phase 2

    // Hilfs-Pfadelement, um die Länge eines Teil-d-Strings zu messen.
    var _measure = null;
    function lengthAtSubPath(d) {
      if (!_measure) _measure = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      _measure.setAttribute('d', d);
      return _measure.getTotalLength();
    }

    // ── MOBILE-GEOMETRIE: eigener kompakter Kreis in STAGE-PIXELN. Das SVG bekommt
    // viewBox = Stage-Maße und liegt deckungsgleich über der Stage → toPx() ist dort
    // praktisch Identität und die draw()-Maschinerie funktioniert 1:1. ──
    var mob = null;          // { cx, cy, r, flightLen }
    var flightPath = null;   // unsichtbarer Flug-Pfad (Einflug + Umrundung + Landung)

    function circlePt(cx, cy, r, deg) {
      var a = deg * Math.PI / 180;
      return { x: cx + Math.cos(a) * r, y: cy - Math.sin(a) * r };
    }

    // Mobile-Pfad: Einflug (unten-links außerhalb → Kreis-Ansatz links, tangential),
    // Umrundung (voller Kreis im Uhrzeigersinn ab 180°), Landung (Bogen in die Mitte).
    function mobilePathD(cx, cy, r, W) {
      var p0 = circlePt(cx, cy, r, 180);
      var inX = -0.25 * W, inY = cy + r * 1.15;
      var entry = 'M ' + inX + ' ' + inY +
                  ' C ' + (inX + (p0.x - inX) * 0.45).toFixed(2) + ' ' + inY +
                  ' ' + p0.x + ' ' + (p0.y + r * 0.6).toFixed(2) +
                  ' ' + p0.x + ' ' + p0.y;
      var pMid = circlePt(cx, cy, r, 0);
      var loop = ' A ' + r + ' ' + r + ' 0 0 1 ' + pMid.x + ' ' + pMid.y +
                 ' A ' + r + ' ' + r + ' 0 0 1 ' + p0.x + ' ' + p0.y;
      var land = ' C ' + p0.x + ' ' + (p0.y - r * 0.55).toFixed(2) +
                 ' ' + (cx - r * 0.6).toFixed(2) + ' ' + (cy - r * 0.45).toFixed(2) +
                 ' ' + cx + ' ' + cy;
      return { d: entry + loop + land, entryPlusLoop: entry + loop };
    }

    // SVG deckungsgleich über die Stage legen und beide Pfade schreiben. Der
    // sichtbare gepunktete Pfad zeigt Einflug + Umrundung; nur die Landung in die
    // Kreismitte bleibt ohne Punkte.
    function setupMobilePath() {
      if (!mob) return;
      var sr = stage.getBoundingClientRect();
      svg.setAttribute('viewBox', '0 0 ' + sr.width + ' ' + sr.height);
      svg.setAttribute('preserveAspectRatio', 'none');

      var paths = mobilePathD(mob.cx, mob.cy, mob.r, sr.width);
      if (!flightPath) {
        flightPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        flightPath.setAttribute('fill', 'none');
        flightPath.setAttribute('stroke', 'none');
        svg.appendChild(flightPath);
      }
      flightPath.setAttribute('d', paths.d);
      mob.flightLen = flightPath.getTotalLength();

      pathEl.setAttribute('d', paths.entryPlusLoop);
      if (revealEl) revealEl.setAttribute('d', paths.entryPlusLoop);
      pathLen = pathEl.getTotalLength();
      pathEl.setAttribute('stroke-width', DOT_W_PX);
      pathEl.setAttribute('stroke-dasharray', '0.01 ' + (DOT_GAP_PX + DOT_W_PX));
      if (revealEl) revealEl.setAttribute('stroke-width', (DOT_W_PX + 8));

      // Avatar-Reveal: nächstgelegener Punkt auf dem Pfad → Anteil 0..1.
      avatarFracs = avatars.map(function (a) {
        var ax = parseFloat(a.style.left), ay = parseFloat(a.style.top);
        var bestL = 0, bestD = Infinity;
        for (var s = 0; s <= 240; s++) {
          var pl = s / 240 * pathLen, p = pathEl.getPointAtLength(pl);
          var dd = (p.x - ax) * (p.x - ax) + (p.y - ay) * (p.y - ay);
          if (dd < bestD) { bestD = dd; bestL = pl; }
        }
        return pathLen ? bestL / pathLen : 0;
      });
    }

    // Desktop-Pfad: fester d-String um DESKTOP_SCALE × Ellipse-Faktoren skaliert.
    // Als Funktion, weil die Ellipse-Stufe mit der Fensterhöhe wechselt (onResize).
    var exitLen = 0;
    function buildDesktopPath() {
      readEllipse();
      var kx = DESKTOP_SCALE * EK.x, ky = DESKTOP_SCALE * EK.y;
      var dStr = scalePathD(PATH_D, CX, CY, kx, ky);
      pathEl.setAttribute('d', dStr);
      if (revealEl) revealEl.setAttribute('d', dStr);
      exitLen = lengthAtSubPath(scalePathD(EXIT_D, CX, CY, kx, ky));
    }
    buildDesktopPath();

    // Effektiver CSS-Scale der Scale-Ebenen: getBoundingClientRect() liefert
    // SKALIERTE Maße; der Faktor wird herausgerechnet, damit toPx() in UNGESCALTEN
    // Stage-Koordinaten arbeitet (sonst doppelte Skalierung der Positionen).
    function stageScale() {
      var r = scaleEl.getBoundingClientRect();
      var w = scaleEl.offsetWidth;
      return (w && r.width) ? r.width / w : 1;
    }
    // SVG-Box (feste Pixelgröße, zentriert) relativ zur Ebene, in ungescalten px.
    function svgBox() {
      var sc = stageScale();
      var sr = scaleEl.getBoundingClientRect();
      var br = svg.getBoundingClientRect();
      return { left: (br.left - sr.left) / sc, top: (br.top - sr.top) / sc, w: br.width / sc, h: br.height / sc };
    }
    // viewBox-Punkt → Pixel relativ zur Stage.
    function toPx(p) {
      var b = svgBox();
      return { x: b.left + (p.x / VBW) * b.w, y: b.top + (p.y / VBH) * b.h };
    }
    // Aktuelle Skalierung viewBox→Pixel.
    function vbScale() {
      var b = svgBox();
      return b.w ? b.w / VBW : 1;
    }

    // Punktgröße/-abstand aus den Editor-Pixelwerten in viewBox-Einheiten setzen,
    // damit sie als echte Pixel rendern (das SVG wird skaliert).
    function applyPathStyle() {
      if (isMobile()) return;   // Mobile: setzt setupMobilePath()
      var s = vbScale();
      if (!s) return;
      var w = DOT_W_PX / s, gap = DOT_GAP_PX / s;
      pathEl.setAttribute('stroke-width', w.toFixed(2));
      // Punkt = sehr kurzer Dash (0.01) + Lücke (skaliert mit der Linienstärke).
      pathEl.setAttribute('stroke-dasharray', '0.01 ' + (gap + w).toFixed(2));
      // Reveal-Maske dicker als die Punkte, damit das Schweif-Fenster sie abdeckt.
      if (revealEl) revealEl.setAttribute('stroke-width', (w + 8 / s).toFixed(2));
    }

    // Avatare in Pixeln positionieren; Badges ausblenden, wenn der äußerste Avatar
    // aus dem Fenster ragt.
    function layoutAvatars() {
      if (isMobile()) {
        // MOBILE: echter Kreis, gleichmäßig auf 360° verteilt, Start um 360/(2N)
        // versetzt (oben Paar, Seiten je 1, unten Paar). Alle Maße proportional
        // zur Stage-Breite → der Kreis sieht bei jeder Breite identisch aus.
        stage.classList.remove('bj-hide-bubbles');
        var mr = stage.getBoundingClientRect();
        var W = mr.width, mcx = W / 2;
        var avSize = W * 0.185;
        stage.style.setProperty('--bj-av-size', avSize + 'px');
        var half = avSize / 2;
        var rM = W * 0.30;
        var mcy = rM + half;
        var step = 2 * Math.PI / N;
        var startA = step / 2;
        avatars.forEach(function (a, i) {
          var ang = startA + i * step;
          var mx = mcx + Math.sin(ang) * rM, my = mcy - Math.cos(ang) * rM;
          avatarBase[i] = { x: mx, y: my };
          a.style.left = mx + 'px';
          a.style.top = my + 'px';
        });
        mob = { cx: mcx, cy: mcy, r: rM };
        setupMobilePath();
        // Headline sitzt relativ unter der Kreis-Unterkante (CSS padding-top);
        // Stage-Höhe fluid = Kreis-Unterkante + Headline-Höhe.
        var circleBottom = mcy + rM + half;
        stage.style.setProperty('--bj-circle-bottom', circleBottom + 'px');
        var hl = section.querySelector('.bj-headline-1');
        stage.style.setProperty('--bj-stage-h', (circleBottom + (hl ? hl.scrollHeight : 0)) + 'px');
        return;
      }
      var sr = scaleEl.getBoundingClientRect();
      var vw = document.documentElement.clientWidth || window.innerWidth;
      var sc = stageScale();
      var anyOut = false;
      avatars.forEach(function (a, i) {
        var p = toPx(ptOnCircle(avatarAngle(i)));
        avatarBase[i] = p;
        a.style.left = p.x + 'px';
        a.style.top = p.y + 'px';
        var half = (a.offsetWidth * sc) / 2 || 60;
        var vpx = sr.left + p.x * sc;
        if (vpx - half < 0 || vpx + half > vw) anyOut = true;
      });
      stage.classList.toggle('bj-hide-bubbles', anyOut);
    }
    layoutAvatars();
    applyPathStyle();

    // Klassischer Scroll-Fortschritt 0→1 über die Stage-Durchquerung (Fallback
    // ohne Pin: Theme-Editor, reduced motion, kein GSAP).
    function progress() {
      var r = stage.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var startAt = vh * 1.25;
      var endAt = isMobile() ? vh * 0.21 : vh * -0.41;
      var t = (startAt - r.top) / (startAt - endAt);
      return t < 0 ? 0 : (t > 1 ? 1 : t);
    }

    var pathLen = pathEl.getTotalLength();

    // Der Referenz-Pfad ist gegen die Flugrichtung orientiert (beginnt unten-mitte,
    // endet am 9-Uhr-Punkt); der Vogel startet links-oben. dist() misst rückwärts.
    function dist(frac) { return pathLen * (1 - frac); }

    // Logischer Pfad-Fortschritt (0..1) eines Avatars → wann der Vogel ihn enthüllt.
    function avatarPathFrac(i) {
      var c = ptOnCircle(avatarAngle(i));
      var bestL = 0, bestD = Infinity;
      for (var s = 0; s <= 200; s++) {
        var pl = s / 200 * pathLen;
        var p = pathEl.getPointAtLength(pl);
        var dd = (p.x - c.x) * (p.x - c.x) + (p.y - c.y) * (p.y - c.y);
        if (dd < bestD) { bestD = dd; bestL = pl; }
      }
      return pathLen ? 1 - bestL / pathLen : 0;
    }
    var avatarFracs = [];
    function computeDesktopFracs() {
      avatarFracs = avatars.map(function (_, i) { return avatarPathFrac(i); });
    }
    // avatarPathFrac() tastet den Pfad mit je 200 getPointAtLength()-Aufrufen ab (teure
    // SVG-Geometrie, pro Avatar) — auf Mobile gewinnt ohnehin setupMobilePath() mit
    // eigener Geometrie, die Desktop-Fracs wären sofort verworfene Rechenarbeit.
    if (isMobile()) { setupMobilePath(); } else { computeDesktopFracs(); }

    // ── PHASE 2 (gepinnt): nach dem Flug sliden Headline/Bubbles raus, die Avatare
    // fliegen auf ihre Ziel-Slots und der Vogel landet auf den Träger:innen. ──
    var ph2 = section.querySelector('.bj-ph2');
    var ph2HeadEl = ph2 ? ph2.querySelector('.bj-ph2-headline') : null;
    var pinP = null;    // Gesamt-Pin-Fortschritt 0..1 (null = klassischer Modus)
    var pinST = null;   // ScrollTrigger-Instanz des Pins
    // Pin-Modus-EINHEITEN sofort festlegen (pinP = 0), wenn der Pin beim load-Event
    // kommen wird — sonst rendert die Zeit bis dahin in klassischen Einheiten und
    // die BEDEUTUNG von curT wechselte beim Anlegen des Pins (Avatare sprängen).
    if (ph2
        && !(window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode))
        && !(window.prefersReducedMotion && window.prefersReducedMotion())) {
      pinP = 0;
    }

    // Flug-Strecke in vh: Mobile 28vh (kürzer → weniger Scrollen für die Animation),
    // Desktop 60vh.
    function flyVh() { return isMobile() ? 0.28 : 0.6; }
    // Phase-2-Strecke: die Morph-Animation ist visuell FERTIG, bevor der interne
    // Fortschritt 1.0 erreicht (Desktop bei ~0.85, Mobile — wg. spätem Text — ~0.95).
    // Nur diesen genutzten Anteil pinnen, sonst bleibt die Section nach dem letzten
    // sichtbaren Frame noch fixiert stehen (tote Zone). renderAt() streckt den
    // Fortschritt entsprechend, sodass p=PH2_USED genau ans Pin-Ende fällt.
    function ph2Used() { return isMobile() ? 0.95 : 0.85; }
    function ph2Vh() { return ph2Used(); }
    function pinVh() { return flyVh() + ph2Vh(); }
    function flyFrac() { return flyVh() / pinVh(); }
    // Vorlauf VOR dem Pin: beim Reinscrollen der Section läuft bereits ein großer
    // Teil des Flugs (Einflug + erste Avatar-Reveals); der Pin übernimmt nahtlos.
    // Mobile kürzer (0.55 statt 0.9), damit der Flug-Teil weniger Scroll-Weg braucht.
    function preFly() { return isMobile() ? 0.55 : 1.2; }
    function preFrac() { return preFly() * flyFrac(); }
    // Vorlauf-Fenster: beginnt 0.25 vh bevor die Fenster-Unterkante die
    // Section-Oberkante überquert, endet am Pin-Start.
    function prePinT() {
      var r = section.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var t = 1 - r.top / (1.25 * vh);
      return t < 0 ? 0 : (t > 1 ? 1 : t);
    }
    // Scroll-Ziel der Gesamt-Timeline: Pin-Fortschritt, davor negativer Vorlauf.
    function scrollTarget() {
      return pinP !== null ? pinP + (prePinT() - 1) * preFrac() : progress();
    }

    var ph2Targets = [];   // pro Avatar: Ziel {x, y, s} oder null
    var ph2Exit = null;    // Vogel-Position am Kreis-Ausstieg (Stage-Pixel)
    var hl1 = section.querySelector('.bj-headline-1');

    // Layout-Position über die offsetParent-Kette: immun gegen laufende Transforms.
    function docPos(el) {
      var x = 0, y = 0;
      while (el) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; }
      return { x: x, y: y };
    }
    function stagePos(el) {
      var a = docPos(el), s = docPos(stage);
      return { x: a.x - s.x, y: a.y - s.y };
    }

    function measurePhase2() {
      ph2Targets = []; ph2Exit = null;
      if (!ph2) return;
      // Slots liegen im UNGESCALTEN ph2, Avatare in der ggf. skalierten Stage —
      // Ziele in ungescalte Stage-Koordinaten umrechnen (X um die Stage-Mitte).
      var sc2 = stageScale() || 1;
      var sw2 = stage.offsetWidth;
      // Die Bild-Komposition (.bj-ph2-main) wird bei flachen Fenstern per CSS
      // skaliert (origin right center) — Slot-Ziele in die VISUELLE Position
      // mappen: P' = Origin + k2 * (P − Origin).
      var mainEl = ph2.querySelector('.bj-ph2-main');
      var k2 = 1, kcx = 0, kcy = 0;
      if (mainEl && mainEl.offsetWidth) {
        k2 = (mainEl.getBoundingClientRect().width / mainEl.offsetWidth) || 1;
        var cp = stagePos(mainEl);
        // Transform-Origin von .bj-ph2-main ist TOP CENTER (gestapeltes Layout):
        // Slot-Ziele um die horizontale Mitte + OBEREN Rand skalieren.
        kcx = cp.x + mainEl.offsetWidth / 2;
        kcy = cp.y;
      }
      // Gestapeltes Desktop-Layout (Text OBEN, Grafik DARUNTER, beide zentriert):
      // die Textspalte darf NICHT mehr auf die Grafikhöhe gestreckt werden (das
      // war das alte Nebeneinander-Layout). Höhe/align-self immer zurücksetzen.
      if (ph2HeadEl) {
        ph2HeadEl.style.height = '';
        ph2HeadEl.style.alignSelf = '';
      }
      avatars.forEach(function (a, i) {
        var slot = ph2.querySelector('[data-bj-slot="' + i + '"]');
        if (!slot) { ph2Targets[i] = null; return; }
        var sp = stagePos(slot);
        var img = a.querySelector('.bj-avatar-img');
        var aw = img ? img.offsetWidth : 144;
        var tx = sp.x + slot.offsetWidth / 2;
        var ty = sp.y + slot.offsetHeight / 2;
        if (k2 !== 1) { tx = kcx + (tx - kcx) * k2; ty = kcy + (ty - kcy) * k2; }
        ph2Targets[i] = {
          x: sw2 / 2 + (tx - sw2 / 2) / sc2,
          y: ty / sc2,
          s: aw ? (slot.offsetWidth * k2) / (aw * sc2) : 0.3
        };
      });
      // Übergabepunkt des Vogels: Desktop = Kreis-Ausstieg (3 Uhr), Mobile = Mitte.
      if (isMobile()) {
        ph2Exit = mob ? { x: mob.cx, y: mob.cy } : null;
      } else if (pathLen) {
        ph2Exit = toPx(pathEl.getPointAtLength(exitLen));
      }
    }

    function ez(v) { return v <= 0 ? 0 : v >= 1 ? 1 : v * v * (3 - 2 * v); }   // smoothstep

    // Alle Phase-2-Inline-Styles zurücksetzen (beim Zurückscrollen in den Flug).
    var _ph2Was = 0;
    function resetPhase2() {
      if (hl1) { hl1.style.opacity = ''; hl1.style.transform = ''; }
      if (bird) bird.style.opacity = '';
      // Flip-Transition wieder freigeben (der Ausflug scrubbt den Flip inline).
      if (birdFlip) birdFlip.style.transition = '';
      stage.classList.remove('bj-ph2-active');
      svg.style.opacity = '';
      ph2.style.opacity = '0';
      ph2.style.transform = '';
      ph2.style.pointerEvents = '';
      if (ph2HeadEl) { ph2HeadEl.style.opacity = ''; ph2HeadEl.style.transform = ''; }
      // Ausflug-Spur zurücksetzen: Dash hinters Pfad-Ende parken (bei Offset 0
      // malt der 0.01-Dash mit linecap=round einen Punkt am Ausstieg).
      if (exitReveal && exitFlightLen) {
        exitReveal.setAttribute('stroke-dasharray', '0.01 ' + (exitFlightLen + 10));
        exitReveal.setAttribute('stroke-dashoffset', -(exitFlightLen + 5));
      }
      avatars.forEach(function (a, i) {
        var b = avatarBase[i];
        a.style.scale = ''; a.style.opacity = '';
        if (b) { a.style.left = b.x + 'px'; a.style.top = b.y + 'px'; }
      });
      // Inline-Styles der Bubbles zurücknehmen, sonst überstimmen sie die
      // Reveal-Regeln (is-revealed) der Flug-Phase.
      bubbles.forEach(function (b) { if (b) { b.style.opacity = ''; b.style.visibility = ''; } });
    }

    // Glow-Kreis-Öffnung folgt EXAKT dem Vogel: Winkel vom Kreismittelpunkt (CX,CY)
    // zum aktuellen Vogel-Punkt (viewBox-Koordinaten). Ein einziger Mechanismus für
    // Flug UND Ausflug (Phase 2) → synchron, keine unterschiedlichen Steps.
    function updateGlow(pt, extraDeg) {
      if (!glowEl || !pt) return;
      var gdeg = Math.atan2(pt.y - CY, pt.x - CX) * 180 / Math.PI;
      // extraDeg: Weiterdreh, nachdem der Vogel gelandet ist — in DERSELBEN Richtung
      // wie die Vogelbewegung über den unteren Bogen (dort nimmt atan2 zu → addieren).
      if (extraDeg) gdeg += extraDeg;
      glowEl.style.setProperty('--bj-glow-rot', gdeg.toFixed(1) + 'deg');
    }

    function drawPhase2(p) {
      if (!ph2) return;
      // Während der Flug-Phase (p=0) nichts anfassen — draw() steuert Reveal/Vogel.
      if (p <= 0) {
        if (_ph2Was > 0) resetPhase2();
        _ph2Was = 0;
        return;
      }
      _ph2Was = p;
      var pHead = ez(Math.min(1, p / 0.35));                          // Headline raus
      var pMove = ez(Math.max(0, Math.min(1, (p - 0.1) / 0.65)));     // Avatare fliegen
      var pIn   = ez(Math.max(0, Math.min(1, (p - 0.3) / 0.55)));     // Phone/Chat rein

      // Headline + Subtext: fade + slide up (transform ist separat von `translate`).
      if (hl1) {
        hl1.style.opacity = String(1 - pHead);
        hl1.style.transform = 'translateY(' + (-48 * pHead).toFixed(1) + 'px)';
      }

      // Zitat-Bubbles gescrubbt am Scroll ausblenden (Klasse schaltet nur die
      // CSS-Transition ab, damit die opacity dem Scroll 1:1 folgt).
      stage.classList.toggle('bj-ph2-active', p > 0);
      var pBub = 1 - ez(Math.min(1, p / 0.4));
      bubbles.forEach(function (b) {
        if (!b) return;
        b.style.opacity = String(pBub);
        b.style.visibility = pBub <= 0 ? 'hidden' : '';
      });

      // Vogel-Ausflug: linear und SOFORT ab p=0 (ez hätte Anfangssteigung 0 —
      // der Vogel würde am Ausstieg sichtbar stoppen).
      var pFly = Math.min(1, p / 0.65);
      var eFly = exitFlightLen ? exitFlightLen * pFly : 0;

      // Schweif: EIN durchgehender Wipe über Kreis-Rest + Ausflug-Spur — fertig
      // bei p=0.6, bevor Phone/Chat voll eingeblendet sind. Mobile: SVG faden.
      if (isMobile()) {
        svg.style.opacity = String(1 - pHead);
      } else if (revealEl && pathLen) {
        var flown = pathLen - exitLen;
        var wp = Math.min(1, p / 0.6);
        var tailPos = wp * wp * (flown + exitFlightLen);
        var tailEnd = pathLen - Math.min(tailPos, flown);
        // Kollabiertes Fenster HINTER das Pfad-Ende parken (Punkt-Artefakt).
        var visC = tailEnd - exitLen;
        revealEl.setAttribute('stroke-dasharray', Math.max(0.01, visC) + ' ' + (pathLen + 10));
        revealEl.setAttribute('stroke-dashoffset', visC > 0.01 ? -exitLen : -(pathLen + 5));
        // Ausflug-Spur: hinter dem Vogel wachsen (bis eFly), vorne frisst derselbe
        // Wipe nach, sobald er den Kreis-Rest aufgebraucht hat.
        var landTail = Math.max(0, tailPos - flown);
        if (exitReveal && exitFlightLen) {
          var visX = eFly - landTail;
          exitReveal.setAttribute('stroke-dasharray', Math.max(0.01, visX) + ' ' + (exitFlightLen + 10));
          exitReveal.setAttribute('stroke-dashoffset', visX > 0.01 ? -landTail : -(exitFlightLen + 5));
        }
        if (grad && p > 0) {
          var tp = (tailPos > flown && exitFlightLen)
            ? exitFlightPath.getPointAtLength(Math.min(exitFlightLen, landTail))
            : pathEl.getPointAtLength(tailEnd);
          var hp = exitFlightLen ? exitFlightPath.getPointAtLength(eFly) : pathEl.getPointAtLength(exitLen);
          grad.setAttribute('x1', tp.x); grad.setAttribute('y1', tp.y);
          grad.setAttribute('x2', hp.x); grad.setAttribute('y2', hp.y);
        }
      }

      // Avatare: vom Kreis auf die Ziel-Slots lerpen (Position + Scale). Avatare
      // ohne Slot (mehr Avatare als Plätze) faden aus.
      avatars.forEach(function (a, i) {
        var b = avatarBase[i], t2 = ph2Targets[i];
        if (!b) return;
        if (t2) {
          a.style.left = (b.x + (t2.x - b.x) * pMove).toFixed(1) + 'px';
          a.style.top  = (b.y + (t2.y - b.y) * pMove).toFixed(1) + 'px';
          a.style.scale = (1 + (t2.s - 1) * pMove).toFixed(3);
        } else {
          a.style.opacity = pMove > 0 ? String(1 - pMove) : '';
        }
      });

      // Vogel weiterfliegen lassen.
      if (bird && ph2Exit && p > 0) {
        if (isMobile()) {
          // Mobile: Vogel fliegt von der Kreismitte (ph2Exit) zu einem Punkt ÜBER
          // den beiden Träger-Avataren (ph2Targets[0/1]) und landet dort — kein
          // Ausflug-Pfad (nur Desktop), daher linearer Lerp mit pMove.
          var _m0 = ph2Targets[0], _m1 = ph2Targets[1];
          var _mSlot = ph2 ? ph2.querySelector('.bj-ph2-slot--wearer') : null;
          var _mr = _mSlot ? (_mSlot.offsetWidth / 2) : 30;
          var _mtx, _mty;
          if (_m0 && _m1) {
            _mtx = (_m0.x + _m1.x) / 2;
            _mty = Math.min(_m0.y, _m1.y) - _mr - 30;   // über den Avatar-Köpfen
          } else if (_m0) {
            _mtx = _m0.x; _mty = _m0.y - _mr - 30;
          } else {
            _mtx = ph2Exit.x; _mty = ph2Exit.y;
          }
          bird.style.opacity = '';
          bird.style.left = (ph2Exit.x + (_mtx - ph2Exit.x) * pMove).toFixed(1) + 'px';
          bird.style.top  = (ph2Exit.y + (_mty - ph2Exit.y) * pMove).toFixed(1) + 'px';
          bird.style.transform = 'translate(-50%, -50%)';
          if (birdFlip) birdFlip.style.transform = 'scaleX(1)';
        } else if (exitFlightLen) {
          // Desktop: der Vogel fliegt den Ausflug-Bogen und landet sichtbar auf
          // den Träger:innen-Avataren; Rotation aus der Pfad-Tangente.
          var pB2 = exitFlightPath.getPointAtLength(eFly);
          // Tangente stabil samplen — am Pfad-ENDE rückwärts (eFly+4 wäre geclampt
          // und ergäbe Richtung (0,0) → der geparkte Vogel schnappte zurück).
          var _f1 = Math.max(0, Math.min(exitFlightLen - 4, eFly));
          var pD1 = exitFlightPath.getPointAtLength(_f1);
          var pD2 = exitFlightPath.getPointAtLength(_f1 + 4);
          var angR = Math.atan2(pD2.y - pD1.y, pD2.x - pD1.x) * 180 / Math.PI;
          if (angR < 0) angR += 360;
          // Wende GESCRUBBT statt Totzonen-Flip mit CSS-Transition (die liefe
          // zeitbasiert weiter — Vogel drehte sich sichtbar beim Scroll-Stopp):
          // über das Tangenten-Fenster 100°→160° dreht scaleX kontinuierlich 1→−1.
          var tw = Math.max(0, Math.min(1, (angR - 100) / 60));
          var ang2 = angR * 0.5 - 90 * tw;
          var flipX = 1 - 2 * tw;
          // SETTLE: die letzten ~18% in eine Ruhepose überblenden (nach links
          // schauend, leicht nach oben geneigt) — rein scroll-basiert.
          var settle = Math.max(0, Math.min(1, (eFly - exitFlightLen * 0.82) / (exitFlightLen * 0.18)));
          if (settle > 0) {
            var se = ez(settle);
            ang2 = ang2 * (1 - se) + (-8) * se;
            flipX = flipX * (1 - se) + (-1) * se;
          }
          var bp2 = toPx(pB2);
          bird.style.left = bp2.x.toFixed(1) + 'px';
          bird.style.top  = bp2.y.toFixed(1) + 'px';
          bird.style.transform = 'translate(-50%, -50%) rotate(' + ang2.toFixed(1) + 'deg)';
          if (birdFlip) {
            birdFlip.style.transition = 'none';    // Flip gescrubbt, nicht animiert
            birdFlip.style.transform = 'scaleX(' + flipX.toFixed(3) + ')';
          }
          // Glow folgt dem Vogel SYNCHRON (pB2 = Position bei eFly). Nachdem der
          // Vogel gelandet ist (pFly=1 ab p=0.65), dreht der Kreis noch ein Stück
          // linear WEITER (extraDeg über p 0.65→1), statt einzufrieren.
          var glowExtra = pFly >= 1 ? Math.max(0, (p - 0.65) / 0.35) * 60 : 0;
          updateGlow(pB2, glowExtra);
        } else {
          // Fallback (Ausflug-Pfad nicht messbar): senkrechter Abgang.
          var srB = stage.getBoundingClientRect();
          var scB = stageScale() || 1;
          var outY = ((window.innerHeight || 800) - srB.top) / scB + 220;
          bird.style.left = ph2Exit.x.toFixed(1) + 'px';
          bird.style.top  = (ph2Exit.y + (outY - ph2Exit.y) * pMove).toFixed(1) + 'px';
          bird.style.transform = 'translate(-50%, -50%) rotate(' + (30 * pMove).toFixed(1) + 'deg)';
          if (birdFlip) birdFlip.style.transform = 'scaleX(1)';
        }
      }

      // Phone + Träger:innen einblenden (leichter Slide von unten).
      ph2.style.opacity = String(pIn);
      ph2.style.transform = 'translateY(' + (28 * (1 - pIn)).toFixed(1) + 'px)';
      // CTAs klickbar, sobald Phase 2 praktisch voll eingeblendet ist.
      ph2.style.pointerEvents = pIn > 0.6 ? 'auto' : '';
      // MOBILE: der Textblock steht ÜBER der Grafik — eigenes SPÄTES Fenster
      // (0.65→0.95), damit die durchfliegenden Avatare nicht überlappen.
      if (ph2HeadEl) {
        if (isMobile()) {
          var pTxt = ez(Math.max(0, Math.min(1, (p - 0.65) / 0.3)));
          ph2HeadEl.style.opacity = String(pTxt);
          ph2HeadEl.style.transform = 'translateY(' + (16 * (1 - pTxt)).toFixed(1) + 'px)';
        } else if (ph2HeadEl.style.opacity !== '') {
          ph2HeadEl.style.opacity = '';
          ph2HeadEl.style.transform = '';
        }
      }
    }

    // Gesamtdarstellung: im Pin-Modus wird v (0..1 über den ganzen Pin) in Flug-
    // und Phase-2-Anteil zerlegt; klassisch ist v direkt der Flug-Fortschritt.
    function renderAt(v) {
      if (pinP !== null && ph2) {
        var FF = flyFrac(), PR = preFrac();
        draw(Math.min(1, Math.max(0, (v + PR) / (FF + PR))));
        // Phase-2-Fortschritt 0..1 über den Pin-Rest, auf den genutzten Anteil
        // skaliert — Morph fertig am Pin-Ende.
        var p2 = Math.max(0, Math.min(1, (v - FF) / (1 - FF)));
        drawPhase2(p2 * ph2Used());
      } else {
        draw(v);
      }
    }
    function redraw() { renderAt(curT != null ? curT : scrollTarget()); }

    function initPin() {
      if (!ph2) return;
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') { pinP = null; return; }
      if (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) return;
      if (window.prefersReducedMotion && window.prefersReducedMotion()) return;
      // Gepinnte Box füllt den Viewport (v.a. Mobile: Stage ist niedriger als 100vh).
      // Desktop: mehr Höhe, damit die gestapelte Phase-2-Grafik (Text oben, Armband+
      // Phone darunter) reinpasst und NICHT in die Folge-Section überläuft.
      section.style.minHeight = isMobile() ? '100vh' : '125vh';
      // iOS/Touch pinnt ohne Smoother per position:fixed — ohne eigenen z-index
      // malt die Folge-Section über den gepinnten Inhalt.
      section.style.position = 'relative';
      section.style.zIndex = '2';
      // VOR dem create() aktivieren: onRefresh feuert bereits beim Anlegen.
      pinP = 0;
      pinST = ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: function () { return '+=' + Math.round((window.innerHeight || 800) * pinVh()); },
        pin: true,
        invalidateOnRefresh: true,
        // Kein Stehenbleiben in einem Zwischenframe des Phase-2-Morphs: Stoppt der
        // Scroll in der Morph-Zone, zieht der Snap ans Finish bzw. zurück davor.
        snap: {
          snapTo: function (value, self) {
            var FF = flyFrac();
            if (value <= FF + 0.001) return value;   // Flugphase: frei scrollen
            var p2 = (value - FF) / (1 - FF);
            var dir = (self && self.direction) || 1;
            if (dir < 0) return p2 > 0.85 ? 1 : FF;
            return p2 < 0.15 ? FF : 1;
          },
          duration: { min: 0.3, max: 0.8 },
          delay: 0.1,
          ease: 'power2.inOut'
        },
        onUpdate: function (self) { pinP = self.progress; onScroll(); },
        onRefresh: function (self) { pinST = self; pinP = self.progress; measurePhase2(); setupEntry(); redraw(); }
      });
      // measurePhase2 VOR setupEntry: der Ausflug-Pfad landet auf den
      // Träger:innen-Slots (ph2Targets[0/1]), die measurePhase2 setzt.
      measurePhase2();
      setupEntry();
      redraw();
    }

    // ── EINFLUG (Desktop): unsichtbarer Anflug von links unten außerhalb des
    // Viewports zum Kreis-Start (9 Uhr). AUSFLUG (Phase 2): großer Ellipsen-Bogen
    // vom Kreis-Ausstieg um die Komposition herum auf die Träger:innen-Avatare;
    // der Vogel hinterlässt eine Punkte-Spur (eigene Reveal-Maske). ──
    var entryPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    entryPath.setAttribute('fill', 'none');
    entryPath.setAttribute('stroke', 'none');
    svg.appendChild(entryPath);
    var entryLen = 0, entrySplit = 0;
    var exitFlightPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    exitFlightPath.setAttribute('fill', 'none');
    exitFlightPath.setAttribute('stroke', 'none');
    exitFlightPath.setAttribute('class', 'bj-exit-line');   // Desktop per CSS ausblenden
    svg.appendChild(exitFlightPath);
    var exitFlightLen = 0, exitReveal = null;

    function setupEntry() {
      entryLen = 0; entrySplit = 0; exitFlightLen = 0;
      if (isMobile() || !pathLen) return;
      var b = svgBox();
      if (!b.w || !b.h) return;
      var S = pathEl.getPointAtLength(pathLen);      // Flug-Start = 9-Uhr-Punkt
      var w = stage.offsetWidth || 1;
      var x0 = ((-0.15 * w) - b.left) / b.w * VBW;
      var y0 = ((stage.offsetHeight * 1.08) - b.top) / b.h * VBH;
      // Ankunft senkrecht von unten — tangential zum Kreis-Start. Erster
      // Kontrollpunkt HÖHER als y0 (nur bis ~55% zwischen y0 und S) statt flach auf
      // y0: sonst knickt die Kurve am unteren Einflug-Ende hart hoch. Zweiter
      // Kontrollpunkt weiter unter S → Ankunft vertikaler = tangential zum Kreis.
      var cp1y = y0 + (S.y - y0) * 0.45;
      var d = 'M ' + x0.toFixed(2) + ' ' + y0.toFixed(2) +
              ' C ' + (x0 + (S.x - x0) * 0.55).toFixed(2) + ' ' + cp1y.toFixed(2) +
              ' ' + S.x.toFixed(2) + ' ' + (S.y + 340).toFixed(2) +
              ' ' + S.x.toFixed(2) + ' ' + S.y.toFixed(2);
      entryPath.setAttribute('d', d);
      entryLen = entryPath.getTotalLength();
      var stopExit = pinP !== null && !!ph2;
      var rest = pathLen - (stopExit ? exitLen : 0);
      entrySplit = entryLen / (entryLen + rest);
      // Einflug nicht längenproportional: er liegt beim Reinscrollen fast komplett
      // unter der Falz — Cap, damit die sichtbare Kreis-Animation früh startet.
      entrySplit = Math.min(entrySplit, 0.08);

      // Ausflug-Ziel: Landepunkt über den beiden Träger:innen-Avataren
      // (ph2Targets[0/1]); Fallback = feste %-Position.
      var E = pathEl.getPointAtLength(exitLen);
      var _txPx, _tyPx;
      var _w0 = ph2Targets[0], _w1 = ph2Targets[1];
      var _wslot = ph2 ? ph2.querySelector('.bj-ph2-slot--wearer') : null;
      var _wr = _wslot ? (_wslot.offsetWidth / 2) : 34;
      if (_w0 && _w1) {
        _txPx = (_w0.x + _w1.x) / 2;
        _tyPx = Math.min(_w0.y, _w1.y) - _wr - 52;   // deutlich über den Avatar-Köpfen
      } else if (_w0) {
        _txPx = _w0.x;
        _tyPx = _w0.y - _wr - 52;
      } else {
        var _vhE = window.innerHeight || 800;
        var _scE = stageScale() || 1;
        var _stTop = docPos(stage).y - docPos(section).y;
        _txPx = PH2_LAND_X * w;
        _tyPx = (PH2_LAND_Y * _vhE - _stTop) / _scE;
      }
      var T = { x: (_txPx - b.left) / b.w * VBW, y: (_tyPx - b.top) / b.h * VBH };
      // Ausflug = der Vogel folgt EINFACH dem KREIS weiter (unterer Halbkreis) ab E
      // (3 Uhr, 0°) im Uhrzeigersinn und biegt erst KURZ vor dem Ziel zum Träger-
      // Punkt T ab. E→B liegt exakt auf dem Kreis (kein Knick, gleicher Radius);
      // B→T ist ein kurzes, tangential anschließendes Abbiegen.
      // Abbiege-Winkel: so weit über den unteren Bogen, dass B nahe/oberhalb T liegt.
      var _bDeg = -175;                                  // fast 9-Uhr — Vogel folgt dem unteren Halbkreis fast komplett, biegt spät ab
      var B = ptOnCircle(_bDeg);
      // Kreis-Radien inkl. Ellipse (identisch zur Pfad-Geometrie) für den A-Arc.
      var _arx = R * EK.x, _ary = R * EK.y;
      // Tangente an B (Uhrzeigersinn) für ein knickfreies Abbiege-Segment B→T.
      var _bPre = ptOnCircle(_bDeg + 3);
      var _btx = B.x - _bPre.x, _bty = B.y - _bPre.y;
      var _btl = Math.sqrt(_btx * _btx + _bty * _bty) || 1;
      _btx /= _btl; _bty /= _btl;
      var _distBT = Math.sqrt((T.x - B.x) * (T.x - B.x) + (T.y - B.y) * (T.y - B.y));
      var _c1x = B.x + _btx * _distBT * 0.5, _c1y = B.y + _bty * _distBT * 0.5;
      var d2 = 'M ' + E.x.toFixed(2) + ' ' + E.y.toFixed(2) +
               ' A ' + _arx.toFixed(2) + ' ' + _ary.toFixed(2) + ' 0 0 1 ' +
               B.x.toFixed(2) + ' ' + B.y.toFixed(2) +
               ' C ' + _c1x.toFixed(2) + ' ' + _c1y.toFixed(2) +
               ' ' + T.x.toFixed(2) + ' ' + (T.y + 20).toFixed(2) +
               ' ' + T.x.toFixed(2) + ' ' + T.y.toFixed(2);
      exitFlightPath.setAttribute('d', d2);
      exitFlightLen = exitFlightPath.getTotalLength();
      if (!exitReveal) {
        var NS = 'http://www.w3.org/2000/svg';
        var xm = document.createElementNS(NS, 'mask');
        xm.setAttribute('id', section.id + '-exit-reveal');
        exitReveal = document.createElementNS(NS, 'path');
        exitReveal.setAttribute('fill', 'none');
        exitReveal.setAttribute('stroke', 'url(#' + (grad ? grad.id : '') + ')');
        exitReveal.setAttribute('stroke-linecap', 'round');
        xm.appendChild(exitReveal);
        svg.querySelector('defs').appendChild(xm);
        exitFlightPath.setAttribute('mask', 'url(#' + section.id + '-exit-reveal)');
        exitFlightPath.setAttribute('stroke', pathEl.getAttribute('stroke'));
        exitFlightPath.setAttribute('stroke-linecap', 'round');
      }
      exitReveal.setAttribute('d', d2);
      var sx = vbScale();
      if (sx) {
        var xw = DOT_W_PX / sx, xgap = DOT_GAP_PX / sx;
        exitFlightPath.setAttribute('stroke-width', xw.toFixed(2));
        exitFlightPath.setAttribute('stroke-dasharray', '0.01 ' + (xgap + xw).toFixed(2));
        exitReveal.setAttribute('stroke-width', (xw + 8 / sx).toFixed(2));
        exitReveal.setAttribute('stroke-dasharray', '0.01 ' + (exitFlightLen + 10));
        exitReveal.setAttribute('stroke-dashoffset', -(exitFlightLen + 5));
      }
    }
    setupEntry();

    // ── MOBILE: Vogel fliegt den Flug-Pfad; Punkte + Reveal laufen über
    // Einflug + Umrundung (gleiche Geometrie wie der Flug-Pfad-Prefix). ──
    function drawMobile(t) {
      if (!mob || !pathLen || !flightPath) return;
      if (svg.offsetParent === null) return;

      var fHead = mob.flightLen * t;
      var fPos = flightPath.getPointAtLength(Math.min(mob.flightLen, Math.max(0, fHead)));
      if (bird) {
        var ahead = flightPath.getPointAtLength(Math.min(mob.flightLen, fHead + 4));
        var dx = ahead.x - fPos.x, dy = ahead.y - fPos.y;
        var ang = Math.atan2(dy, dx) * 180 / Math.PI;
        var flip = 1;
        // Totzone ±100° gegen Flip-Flackern bei fast senkrechter Flugbahn.
        if (ang > 100 || ang < -100) { ang += 180; if (ang > 180) ang -= 360; flip = -1; }
        ang *= 0.5;
        bird.style.left = fPos.x + 'px';
        bird.style.top  = fPos.y + 'px';
        bird.style.transform = 'translate(-50%, -50%) rotate(' + ang.toFixed(1) + 'deg)';
        if (birdFlip) birdFlip.style.transform = 'scaleX(' + flip + ')';
      }

      var head = Math.min(pathLen, Math.max(0, fHead));
      if (revealEl) {
        var tailStart = Math.max(0, head - pathLen * 0.5);
        var visLen = Math.max(0.01, head - tailStart);
        revealEl.setAttribute('stroke-dasharray', visLen + ' ' + (pathLen + 10));
        revealEl.setAttribute('stroke-dashoffset', -tailStart);
        if (grad) {
          var tp = pathEl.getPointAtLength(tailStart);
          var hp = pathEl.getPointAtLength(head);
          grad.setAttribute('x1', tp.x); grad.setAttribute('y1', tp.y);
          grad.setAttribute('x2', hp.x); grad.setAttribute('y2', hp.y);
        }
      }

      var pT = pathLen ? head / pathLen : 0;
      avatars.forEach(function (a, i) {
        a.classList.toggle('is-revealed', pT >= avatarFracs[i] - 0.02);
      });
    }

    function draw(t) {
      if (t == null) t = curT != null ? curT : progress();
      if (isMobile()) { drawMobile(t); return; }
      if (svg.offsetParent === null) return;
      // ── EINFLUG: erstes Flug-Stück außerhalb des Viewports zum Kreis-Start;
      // währenddessen bleibt die Kreis-Logik bei 0.
      var inEntry = false, entryT = 0;
      if (entryLen && entrySplit > 0) {
        if (t < entrySplit) { inEntry = true; entryT = t / entrySplit; t = 0; }
        else { t = (t - entrySplit) / (1 - entrySplit); }
      }
      // Im Pin-Modus stoppt der Vogel am Kreis-Ausstieg (3 Uhr) — den Rest fliegt
      // er in Phase 2 (drawPhase2); klassisch fliegt er den ganzen Kreis.
      var stopAtExit = pinP !== null && !!ph2;
      var head = stopAtExit ? pathLen - (pathLen - exitLen) * t : dist(t);
      var pos = pathEl.getPointAtLength(Math.min(pathLen, Math.max(0, head)));

      var posB = pos, ahead;
      if (inEntry) {
        var eL = entryLen * entryT;
        posB = entryPath.getPointAtLength(eL);
        ahead = entryPath.getPointAtLength(Math.min(entryLen, eL + 4));
      } else {
        ahead = pathEl.getPointAtLength(Math.max(0, head - 4));
      }

      // Schweif-Fenster [head, head + 0.85·pathLen] hinter dem Vogel; Fenster über
      // dashoffset statt führendem 0-Dash (der malte mit linecap=round einen
      // einzelnen Punkt bei Pfadlänge 0).
      if (revealEl) {
        var tailEnd = Math.min(pathLen, head + pathLen * 0.85);
        var visLen = Math.max(0.01, tailEnd - head);
        revealEl.setAttribute('stroke-dasharray', visLen + ' ' + (pathLen + 10));
        revealEl.setAttribute('stroke-dashoffset', -head);
        if (grad) {
          var tp = pathEl.getPointAtLength(tailEnd);
          grad.setAttribute('x1', tp.x); grad.setAttribute('y1', tp.y);
          grad.setAttribute('x2', posB.x); grad.setAttribute('y2', posB.y);
        }
      }

      // Vogel: Rotation/Flip aus der Flugrichtung.
      if (bird) {
        var dx = ahead.x - posB.x, dy = ahead.y - posB.y;
        var ang = Math.atan2(dy, dx) * 180 / Math.PI;
        var flip = 1;
        // Totzone ±100°: am Einflug-Ende ist die Bahn fast exakt senkrecht (−90°) —
        // mit ±90 flippte der Vogel dort doppelt.
        if (ang > 100 || ang < -100) { ang += 180; if (ang > 180) ang -= 360; flip = -1; }
        ang *= 0.5;
        var bp = toPx(posB);
        bird.style.left = bp.x + 'px';
        bird.style.top  = bp.y + 'px';
        bird.style.transform = 'translate(-50%, -50%) rotate(' + ang.toFixed(1) + 'deg)';
        if (birdFlip) birdFlip.style.transform = 'scaleX(' + flip + ')';
        if (bird.style.opacity !== '') bird.style.opacity = '';
      }

      // Glow-Kreis: Öffnung folgt EXAKT dem Vogel (posB), synchron zur Flugbahn.
      updateGlow(posB);

      // Avatar-Reveal: avatarFracs sind gegen den GANZEN Kreis gerechnet → t auf
      // Voll-Pfad-Skala mappen (mit Ausstiegs-Stopp endet die Kreis-Phase früher).
      var tf = stopAtExit ? t * (pathLen - exitLen) / pathLen : t;
      avatars.forEach(function (a, i) {
        a.classList.toggle('is-revealed', tf >= avatarFracs[i] - 0.02);
      });
    }

    // Resize: Geometrie neu aufbauen. Auf Desktop die SVG-Geometrie komplett aus
    // dem Mobile-Zustand zurücksetzen (viewBox!), sonst rendert der Desktop-Pfad
    // in der falschen viewBox.
    function onResize() {
      if (!section.isConnected) return;
      if (!isMobile()) {
        svg.setAttribute('viewBox', '0 0 ' + VBW + ' ' + VBH);
        svg.setAttribute('preserveAspectRatio', 'none');
        buildDesktopPath();   // Ellipse-Stufe kann gewechselt haben
        pathLen = pathEl.getTotalLength();
        computeDesktopFracs();
        layoutAvatars(); applyPathStyle(); setupEntry(); measurePhase2(); redraw();
        return;
      }
      // Mobile: layoutAvatars → setupMobilePath baut Pfad + pathLen + Fracs frisch.
      layoutAvatars(); setupEntry(); measurePhase2(); redraw();
    }
    // Resize über rAF entkoppeln: beim Breakpoint-Wechsel schaltet die Media-Query
    // das SVG-Layout um — Maße erst lesen, wenn das neue Layout berechnet ist.
    // Bei einem live per Maus gezogenen Resize feuert der letzte rAF-Call teils
    // noch im selben Frame wie der letzte Reflow (Media-Query-Wechsel + GSAP/
    // ScrollTrigger-Refresh laufen unabhängig) — die dort gemessenen Rects können
    // dann minimal veraltet sein. Ein Nachlauf 150ms nach dem letzten resize-Event
    // (Drag garantiert beendet, alle Layouts final) korrigiert das zuverlässig.
    var _resizeRaf = null, _resizeSettle = null;
    function onResizeDeferred() {
      if (_resizeSettle) clearTimeout(_resizeSettle);
      _resizeSettle = setTimeout(onResize, 150);
      if (_resizeRaf) return;
      _resizeRaf = requestAnimationFrame(function () { _resizeRaf = null; onResize(); });
    }
    window.addEventListener('resize', onResizeDeferred);
    window.addEventListener('orientationchange', onResizeDeferred);
    // Pin erst im load-Hook: GSAP/ScrollTrigger werden bei DOMContentLoaded
    // registriert, und die Maße (Fonts/Bilder) sind dann final.
    window.addEventListener('load', function () {
      if (!section.isConnected) return;
      layoutAvatars(); setupEntry(); initPin(); measurePhase2(); redraw();
    });
    // Der Armband-Freisteller bestimmt die Höhe der Träger-Spalte — lädt er (lazy)
    // erst nach window.load, wären die Slot-Ziele veraltet. Einmal nachmessen.
    var armImg = section.querySelector('.bj-ph2-armband');
    if (armImg && !armImg.complete) {
      armImg.addEventListener('load', function () { measurePhase2(); redraw(); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setupEntry(); measurePhase2(); redraw(); });
    }

    // ── Scrub: dargestellter Fortschritt folgt dem Scroll-Ziel weich nach (Lerp
    // pro Frame); rAF endet, sobald eingerastet. Reduced motion springt direkt. ──
    var curT = null;
    var SCRUB = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 0.12;
    var scrubRaf = null;
    function scrubTick() {
      scrubRaf = null;
      var target = scrollTarget();
      if (curT === null) curT = target;
      var diff = target - curT;
      if (Math.abs(diff) < 0.0004) {
        curT = target;
        renderAt(curT);
        return;
      }
      curT += diff * SCRUB;
      renderAt(curT);
      scrubRaf = requestAnimationFrame(scrubTick);
    }
    function onScroll() {
      if (!section.isConnected) return;
      if (!scrubRaf) scrubRaf = requestAnimationFrame(scrubTick);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    scrubTick();

    // ── Phase 2: dynamische Wortwechsel-Zeile der Headline (Mechanik wie in
    // product-video-intro). IntersectionObserver pausiert außerhalb des Viewports. ──
    section.querySelectorAll('[data-bj-rotate]').forEach(function (rot) {
      var words = rot.querySelectorAll('.bj-rotate-word');
      if (!words.length) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Fenster mindestens so breit wie die LÄNGSTE Variante, sonst schneidet das
      // overflow-hidden-Fenster lange Zeilen rechts ab. Nach Font-Load + bei
      // Resize nachmessen (clamp-Schriftgröße ändert die Wortbreiten).
      function sizeWindow() {
        var maxW = 0;
        words.forEach(function (w) {
          var t = w.querySelector('.bj-rotate-text');
          if (t) maxW = Math.max(maxW, t.offsetWidth);
        });
        rot.style.minWidth = maxW ? (Math.ceil(maxW) + 1) + 'px' : '';
      }
      sizeWindow();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeWindow);
      window.addEventListener('resize', sizeWindow);

      if (reduce || words.length < 2) return;
      var interval = parseInt(rot.getAttribute('data-bj-interval'), 10) || 3000;
      var idx = 0, timer = null;

      function step() {
        var cur = words[idx];
        idx = (idx + 1) % words.length;
        var next = words[idx];
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        next.classList.add('is-active');
        // Nach dem Slide-out: ohne Transition (is-reset) unten parken.
        setTimeout(function () {
          cur.classList.add('is-reset');
          cur.classList.remove('is-leaving');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { cur.classList.remove('is-reset'); });
          });
        }, 1050);
      }
      function start() { if (!timer) timer = setInterval(step, interval); }
      function stop()  { if (timer) { clearInterval(timer); timer = null; } }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
        }).observe(rot);
      } else {
        start();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bird-journey]').forEach(function (s) {
      if (s.__bjInit) return;
      s.__bjInit = true;
      initBirdJourney(s);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme-Editor: Section-Re-Render lädt das Markup neu → neu initialisieren.
  if (!window.__bjSectionHook) {
    window.__bjSectionHook = true;
    document.addEventListener('shopify:section:load', initAll);
  }
})();
